// import { useLocation } from "react-router-dom";

// const ConsultPaymentWebView = () => {
//   const location = useLocation();
//   const paymentUrl = location.state?.paymentUrl;

//   return (
//     <div style={{ height: "100vh" }}>
//       <iframe
//         src={paymentUrl}
//         title="Consult Payment"
//         style={{ width: "100%", height: "100%", border: "none" }}
//       />
//     </div>
//   );
// };

// export default ConsultPaymentWebView;

import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ConsultPaymentWebView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const paymentUrl = location.state?.paymentUrl;

  useEffect(() => {
    const handleMessage = (event) => {
      // You can add origin validation if needed: if (event.origin !== 'https://connecttovow.com') return;
      const data = event.data;
      console.log("WebView Message:ConsultPaymentWebView", data);

      if (data === "payment_success") {
        console.log("Payment successful! ConsultPaymentWebView");
        // Navigate to "Consult" inside "Tab" or however your routes are structured
        navigate("/Sidebar/Consult"); // Adjust this route based on your app structure
      } else {
        navigate(-1); // Go back
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]);

  return (
    <div style={{ height: "100vh" }}>
      <iframe
        src={paymentUrl}
        title="Consult Payment"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
};

export default ConsultPaymentWebView;
